import { HttpResult } from "widgets-for-react";
import { ThemakiezerApiClient } from "../../../custom_api/generated";

export const fetchEmbed = (embedId: string) => () => httpResult(() => client.getEmbed(embedId))

const client = new ThemakiezerApiClient(window.location.origin)

const httpResult = async <T>(promise: () => Promise<T>): Promise<HttpResult<T>>  => {
  try {
    return {
      kind: 'result',
      value: await promise(),
      status: 200
    }
  } catch (error) {
    console.error(error);
    return {
      kind: 'failed',
      status: 500
    }
  }
};
